import React from "react";

import styles from "./index.module.scss";

interface Props {}

class DesktopFilters extends React.PureComponent<Props> {
  public render() {
    const { children } = this.props;

    return <div className={styles.filtersContainer}>{children}</div>;
  }
}

export { DesktopFilters };
export { default as DesktopFilterGroup } from "./DesktopFilterGroup";
export { default as DesktopFilterItem } from "./DesktopFilterItem";
